let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("40dNe")).then(() => parcelRequire('kriQH'));